(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userLocationSearch', ['SearchService', UserLocationSearchFn]);

    /* user location search directive */
    function UserLocationSearchFn(SearchService) {

        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                detail: '='
            },
            templateUrl: '/app/users/templates/user-location-search.template.html'            
        };
        return directive;

        function link(scope, element) {

            /* search for zipcodes and locations */
            scope.search = function (searchValue) {
                return SearchService.searchZipCodes(searchValue).then(function (result) {
                    return result;
                });
            };

            /* set new zip code if location change */
            scope.locationChanged = function (item, model, label) {
                if (!item) { return; }
                // set zipcode in input
                scope.detail.zipCode = item.zipCode;
                scope.detail.location = label;
            };
            
        } // link

    }

})();